/** QAPI `policy.block_type` values (aligned with KASA `BlockType`). */
export const ROUTINE_BLOCK_TYPE = {
  FILTER_ROUTINE: 0,
  LOCK_NAVIGATION: 1,
  LOCK_DEVICE: 2,
} as const;

export type RoutineBlockType =
  (typeof ROUTINE_BLOCK_TYPE)[keyof typeof ROUTINE_BLOCK_TYPE];
